export default "__VITE_ASSET__RZzheUKb__"